module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm Silver Aluminum + Clementine Open.c67a7689.png";